import NewVideoPlayer from '../Common/NewVideoPlayer';
const RoleplayRecording = ({ videoURL = '', playerRef }) => {
  return (
    <div>
      <h4>📽 Roleplay Recording</h4>
      {videoURL && <NewVideoPlayer url={videoURL} ref={playerRef} />}
    </div>
  );
};

export default RoleplayRecording;
